import { useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { Typography } from 'antd';

import { Paper } from 'componets/ui';
import { RegistrationLayout } from 'componets/layouts';

import { RequestStatus } from 'utils/constants';

import { deleteAccountConfirm } from 'features/userSettings/actions';

import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';

import { selectUser } from 'selectors';

export const AccountDeletingConfirmation = () => {
	const user = useAppSelector(selectUser);
	const status = useAppSelector((state) => state.userSettings.status);

	const [message, setMessage] = useState('');
	const { token } = useParams();

	const { accountDeleteMessageText, linkExpiredText, successText, failureText } = useTranslate([
		'accountDeleteMessageText',
		'linkExpiredText',
		'successText',
		'failureText',
	]);

	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(deleteAccountConfirm({ token }))
			.unwrap()
			.then(() => {
				setMessage(accountDeleteMessageText);
			})
			.catch((e) => {
				setMessage(linkExpiredText);
			});
	}, [dispatch, token]);

	if (status === RequestStatus.PENDING) return null;
	return (
		<RegistrationLayout email={user.email}>
			<Paper>
				<Typography.Title level={4}>
					{status === RequestStatus.FULFILLED ? successText : failureText}
				</Typography.Title>
				<Typography.Text> {message}</Typography.Text>
			</Paper>
		</RegistrationLayout>
	);
};
